<template>
  <div class="input-group mb-3 d-flex flex-column">
    <label class="title-buscador-mobile text-primary mb-2">
      <slot name="label"></slot>
    </label>
    <div
      class="bg-white p-2 rounded-2 d-flex justify-content-between pointer align-items-center"
      :class="hasError ? 'error_select' : ''"
      @click="$emit('click')">
      <span class="title-opcion-mobile">
        <slot name="content"></slot>
      </span>
      <i class="fa-solid fa-chevron-down text-primary" />
    </div>
  </div>
</template>

<script setup>
  defineProps({
    hasError: Boolean,
  });

  defineEmits(['click']);
</script>

<style lang="scss" scoped>
  .title-buscador-mobile {
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .title-opcion-mobile {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: var(--bs-primary);
  }

  .error_select {
    border: 1px solid red;
  }

  .pointer {
    cursor: pointer;
  }

  .input-group {
    margin-bottom: 1rem !important;
  }

  .fa-chevron-down {
    font-size: 12px;
  }

  .bg-white {
    padding: 0.5rem 1rem;
  }
</style>
